import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/ModalActions';
import importImages from '../../../util/webpack';

const modalImages = importImages(require.context('../../../../public/images/doodles/', false, /\.(jpg|jpeg|png|gif|svg)(\?.*)?$/));

const PublishRegistryModal = ({ close }) => (
  <div id="publish-registry-modal" className="publish-share-modal text-center">
    <div className="modal-header">
      <img src={modalImages('gifts1X')} alt="gifts doodle" />
      <h2>All set!</h2>
    </div>
    <div className="modal-body">
      <p className="body-text">Guests can now view and give gifts on your registry.</p>
      <div className="actions">
        <a href="/registry/dashboard" className="btn btn-primary btn-left">Add More Gifts</a>
        <button className="btn btn-secondary btn-right" role="button" onClick={close}>Done</button>
      </div>
    </div>
  </div>
);

PublishRegistryModal.propTypes = {
  close: PropTypes.func
};

const mapStateToProps = state => ({
  slug: state.wedding.wedding.slug
});

const mapDispatchToProps = dispatch => ({
  close: () => dispatch(hideModal())
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishRegistryModal);



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/PublishRegistryModal.jsx
 **/